module.exports = __webpack_public_path__ + "static/media/helpWhite.a3b77e03.svg";